module.exports = __webpack_public_path__ + "media/flags/vn-c06ead49.svg";